var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooterLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 57,
    viewBox: "0 0 123 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.4243 29.9756C38.2661 29.5506 36.9713 30.1215 36.5353 31.2507C36.4377 31.5044 36.2555 31.8279 35.9952 32.1768C35.6113 32.7033 35.0583 33.2616 34.4662 33.7564C33.8741 34.2512 33.2364 34.6825 32.7158 34.968C31.2583 35.7673 29.6967 36.1479 28.1416 36.1479C27.4584 36.1479 26.7751 36.0718 26.1115 35.9322C24.9012 35.6721 23.704 36.4143 23.4307 37.5942C23.1639 38.7741 23.9252 39.9413 25.1354 40.2078C26.118 40.4235 27.1266 40.5313 28.1416 40.5313C30.445 40.5313 32.7874 39.9667 34.9281 38.7868C36.0017 38.1905 37.1405 37.3722 38.1815 36.3763C38.7021 35.8814 39.1966 35.3359 39.6325 34.7459C40.0685 34.156 40.4524 33.5153 40.7322 32.7985C41.1681 31.663 40.5825 30.4006 39.4243 29.9756Z",
    fill: "#7A7AF7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4234 29.9756C38.2651 29.5506 36.9703 30.1215 36.5344 31.2507C36.4367 31.5044 36.2545 31.8279 35.9943 32.1768C35.6104 32.7033 35.0573 33.2616 34.4652 33.7564C33.8731 34.2512 33.2354 34.6825 32.7148 34.968C31.2573 35.7673 29.6957 36.1479 28.1406 36.1479C27.4574 36.1479 26.7742 36.0718 26.1105 35.9322C24.9002 35.6721 23.703 36.4143 23.4297 37.5942C23.1629 38.7741 23.9242 39.9413 25.1345 40.2078C26.117 40.4235 27.1256 40.5313 28.1406 40.5313C30.444 40.5313 32.7864 39.9667 34.9271 38.7868C36.0008 38.1905 37.1395 37.3722 38.1806 36.3763C38.7011 35.8814 39.1956 35.3359 39.6315 34.7459C40.0675 34.156 40.4514 33.5153 40.7312 32.7985C41.1672 31.663 40.5815 30.4006 39.4234 29.9756Z",
    fill: "#FCA311"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8837 26.1249C41.7471 24.1964 41.168 22.2553 40.1269 20.4664C39.2094 18.8869 37.9992 17.5483 36.6132 16.489C35.2208 15.436 33.6461 14.6557 31.9869 14.1863C30.7962 13.8501 29.5534 14.5161 29.2085 15.677C28.8637 16.8379 29.5469 18.0495 30.7376 18.3857C31.8633 18.7029 32.9239 19.2294 33.8608 19.9399C34.7979 20.6504 35.6047 21.5448 36.2293 22.6169C36.9385 23.8349 37.3159 25.1289 37.4136 26.4294C37.4982 27.6347 38.5717 28.5418 39.808 28.4593C41.0378 28.3768 41.9683 27.3301 41.8837 26.1249Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8837 26.1249C41.7471 24.1964 41.168 22.2553 40.1269 20.4664C39.2094 18.8869 37.9992 17.5483 36.6132 16.489C35.2208 15.436 33.6461 14.6557 31.9869 14.1863C30.7962 13.8501 29.5534 14.5161 29.2085 15.677C28.8637 16.8379 29.5469 18.0495 30.7376 18.3857C31.8633 18.7029 32.9239 19.2294 33.8608 19.9399C34.7979 20.6504 35.6047 21.5448 36.2293 22.6169C36.9385 23.8349 37.3159 25.1289 37.4136 26.4294C37.4982 27.6347 38.5717 28.5418 39.808 28.4593C41.0378 28.3768 41.9683 27.3301 41.8837 26.1249Z",
    fill: "#FCA311"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3387 31.0729C34.5575 28.916 34.564 25.4081 32.3517 23.2386C30.1395 21.0691 26.5412 21.0691 24.3159 23.2259C22.0971 25.3827 21.7717 31.371 22.8779 32.4494C23.9775 33.5278 30.1134 33.2297 32.3387 31.0729Z",
    fill: "#FCA311"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3407 31.0734C34.5595 28.9165 34.566 25.4086 32.3537 23.2391C30.1414 21.0696 26.5431 21.0696 24.3178 23.2264C22.099 25.3832 21.7737 31.3715 22.8798 32.4499C23.9795 33.5283 30.1154 33.2302 32.3407 31.0734Z",
    fill: "url(#paint0_linear_597_14515)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8904 18.2903C27.0941 17.9985 27.8228 16.8122 27.5236 15.6387C27.2242 14.4651 26.0075 13.7546 24.8037 14.0465C23.6195 14.3319 22.4547 14.7759 21.3356 15.3913C19.1038 16.6219 17.3469 18.3854 16.1562 20.4154C14.9655 22.4453 14.3408 24.748 14.3408 27.0952C14.3408 27.1776 14.3408 27.2601 14.3408 27.3426V40.6514C14.3408 41.8566 15.3429 42.8399 16.5857 42.8399C17.8284 42.8399 18.8305 41.863 18.8305 40.6514V27.0825C18.8305 27.0761 18.8305 27.0635 18.8305 27.0571C18.837 25.4902 19.2599 23.9424 20.0538 22.5849C20.8541 21.2147 22.0253 20.0348 23.5414 19.1974C24.3027 18.7851 25.09 18.487 25.8904 18.2903Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8899 18.2903C27.0936 17.9985 27.8223 16.8122 27.5231 15.6387C27.2237 14.4651 26.007 13.7546 24.8032 14.0465C23.619 14.3319 22.4543 14.7759 21.3351 15.3913C19.1033 16.6219 17.3464 18.3854 16.1557 20.4154C14.965 22.4454 14.3403 24.748 14.3403 27.0952C14.3403 27.1776 14.3403 27.2601 14.3403 27.3426V40.6514C14.3403 41.8567 15.3424 42.8399 16.5852 42.8399C17.828 42.8399 18.83 41.863 18.83 40.6514V27.0825C18.83 27.0761 18.83 27.0635 18.83 27.0571C18.8365 25.4902 19.2595 23.9424 20.0533 22.5849C20.8536 21.2147 22.0248 20.0348 23.5409 19.1974C24.3022 18.7851 25.0895 18.487 25.8899 18.2903Z",
    fill: "#FCA311"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1018 22.236C53.1669 22.0711 53.1995 21.8872 53.1995 21.7095V21.6778C53.1995 21.5002 53.1669 21.3162 53.1018 21.1513C53.0368 20.9863 52.9327 20.8278 52.8091 20.7009L52.8026 20.6946L52.796 20.6882C52.6659 20.5613 52.5032 20.4535 52.334 20.3837C52.1584 20.314 51.9697 20.2822 51.7875 20.2822H50.9221C50.0632 20.2822 49.2498 20.4281 48.5016 20.7263C47.7533 21.0244 47.0766 21.4748 46.4715 22.0648C45.8794 22.6547 45.4239 23.3145 45.118 24.0376C44.8122 24.7608 44.6561 25.5537 44.6431 26.3911V35.1325C44.6431 35.3102 44.6756 35.4941 44.7472 35.6591C44.8187 35.824 44.9293 35.9762 45.0595 36.1031C45.1896 36.23 45.3458 36.3378 45.5149 36.4076C45.6842 36.4774 45.8729 36.5091 46.055 36.5091H46.1006C46.2828 36.5091 46.4715 36.4774 46.6406 36.4076C46.8098 36.3378 46.966 36.23 47.0961 36.1031C47.2262 35.9762 47.3369 35.824 47.4084 35.6591C47.48 35.4941 47.5126 35.3102 47.5126 35.1325V26.4038C47.5191 25.9343 47.6036 25.5157 47.7663 25.1287C47.929 24.7417 48.1762 24.3865 48.5081 24.0566C48.8464 23.7268 49.2108 23.4857 49.6077 23.3272C50.0046 23.1685 50.4341 23.0861 50.9156 23.0861H51.781C51.9697 23.0861 52.1584 23.0544 52.3275 22.9846C52.5032 22.9148 52.6594 22.8133 52.7895 22.6801C52.9262 22.5595 53.0303 22.4073 53.1018 22.236Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5638 22.6611C65.7574 21.8745 64.8594 21.2782 63.8699 20.8785C62.881 20.4789 61.8142 20.2822 60.6752 20.2822C59.5368 20.2822 58.4629 20.4789 57.4805 20.8785C56.4916 21.2782 55.5936 21.8745 54.7867 22.6611C53.9799 23.4477 53.3682 24.3231 52.9583 25.2873C52.5484 26.2515 52.3467 27.2919 52.3467 28.402C52.3467 29.5121 52.5484 30.5588 52.9583 31.5167C53.3682 32.4809 53.9799 33.3563 54.7867 34.1429C55.5936 34.9295 56.4916 35.5258 57.4805 35.9255C58.4695 36.3251 59.5368 36.5217 60.6752 36.5217C61.8142 36.5217 62.8876 36.3251 63.8699 35.9255C64.8594 35.5258 65.7574 34.9295 66.5638 34.1429C67.3707 33.3563 67.9824 32.4809 68.3922 31.5167C68.8021 30.5524 69.0039 29.5121 69.0039 28.402C69.0039 27.2919 68.8021 26.2452 68.3922 25.2873C67.9758 24.3231 67.3641 23.4477 66.5638 22.6611ZM64.5208 32.2018C63.9874 32.7283 63.4083 33.1153 62.7706 33.3753C62.133 33.6355 61.443 33.7623 60.6752 33.7623C59.9141 33.7623 59.218 33.6291 58.5804 33.3753C57.9427 33.1153 57.357 32.7283 56.817 32.2018C56.2831 31.6753 55.8865 31.1044 55.6262 30.4827C55.3658 29.861 55.229 29.1886 55.229 28.4527C55.229 27.7106 55.3592 27.0318 55.6262 26.4101C55.8865 25.7884 56.2831 25.2175 56.817 24.691C57.357 24.1645 57.9427 23.7775 58.5804 23.5175C59.218 23.2574 59.9141 23.1305 60.6752 23.1305C61.443 23.1305 62.1391 23.2637 62.7706 23.5175C63.4083 23.7775 63.9874 24.1645 64.5142 24.691C65.0541 25.2175 65.4513 25.7884 65.7182 26.4165C65.9846 27.0381 66.1148 27.7169 66.1148 28.4591C66.1148 29.1949 65.9786 29.8674 65.7182 30.489C65.4579 31.098 65.0608 31.6689 64.5208 32.2018Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1909 22.6611C83.384 21.8745 82.486 21.2782 81.497 20.8785C80.5081 20.4789 79.4408 20.2822 78.3023 20.2822C77.1633 20.2822 76.09 20.4789 75.1076 20.8722C74.1248 21.2655 73.2268 21.8618 72.4265 22.642C71.6195 23.4286 71.0084 24.3041 70.598 25.2619C70.1882 26.2198 69.9803 27.2602 69.9736 28.3703V41.2224C69.9736 41.4 70.0062 41.5839 70.0779 41.7489C70.149 41.9138 70.2599 42.0661 70.3901 42.1929C70.5202 42.3198 70.6763 42.4276 70.8457 42.4974C71.0144 42.5672 71.2031 42.5989 71.3857 42.5989H71.4309C71.6135 42.5989 71.8021 42.5672 71.9709 42.4974C72.1402 42.4276 72.2963 42.3198 72.4265 42.1929C72.5566 42.0661 72.6675 41.9138 72.7392 41.7489C72.8104 41.5839 72.8429 41.4 72.8429 41.2224V34.4792C73.598 35.0437 74.3525 35.5005 75.1203 35.8303C76.1678 36.2871 77.2284 36.5155 78.2891 36.5155C79.4281 36.5155 80.5014 36.3188 81.4838 35.9191C82.4733 35.5195 83.3713 34.9232 84.1777 34.1366C84.9846 33.35 85.5963 32.4746 86.0061 31.5104C86.4159 30.5461 86.6178 29.5058 86.6178 28.3956C86.6178 27.2855 86.4159 26.2388 86.0061 25.281C85.6095 24.3231 84.9978 23.4477 84.1909 22.6611ZM82.1479 32.1256C81.614 32.6522 81.0348 33.0392 80.4038 33.2993C79.7662 33.5593 79.0767 33.6862 78.309 33.6862C77.5472 33.6862 76.8512 33.553 76.2135 33.2993C75.5759 33.0392 74.9902 32.6522 74.4502 32.1256C73.9168 31.5991 73.5197 31.0282 73.2593 30.4066C72.999 29.7849 72.8628 29.1125 72.8628 28.3766C72.8628 27.6344 72.9929 26.9556 73.2593 26.334C73.5197 25.7123 73.9168 25.1414 74.4502 24.6149C74.9902 24.0947 75.5759 23.7078 76.2135 23.454C76.8512 23.2003 77.5472 23.0671 78.309 23.0671C79.0701 23.0671 79.7662 23.1939 80.3972 23.454C81.0348 23.7078 81.614 24.0947 82.1545 24.6149C82.6945 25.1414 83.0911 25.7123 83.358 26.3403C83.625 26.962 83.7552 27.6408 83.7552 28.383C83.7552 29.1188 83.6184 29.7912 83.358 30.4129C83.0911 31.0282 82.6945 31.5928 82.1479 32.1256Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M103.985 30.2038C103.939 30.0706 103.874 29.9501 103.796 29.8359L103.79 29.8296L103.783 29.8232C103.646 29.6456 103.477 29.4933 103.275 29.3918C103.074 29.2903 102.846 29.2459 102.619 29.2459C102.469 29.2459 102.319 29.265 102.176 29.303C101.961 29.3601 101.759 29.4743 101.596 29.6266C101.434 29.7788 101.323 29.9754 101.245 30.1848C101.056 30.7176 100.803 31.1871 100.484 31.6121C100.165 32.0371 99.7746 32.4114 99.313 32.7412C98.8315 33.0838 98.324 33.3375 97.7901 33.5088C97.2567 33.6801 96.6969 33.7626 96.1051 33.7626C95.2137 33.7626 94.4002 33.5596 93.6324 33.1536C93.0141 32.8237 92.4289 32.3606 91.869 31.7516C93.1056 31.2125 94.9468 30.4068 97.3869 29.3284C99.6969 28.3134 101.558 27.4951 102.976 26.8735H102.983H102.989C103.152 26.7973 103.308 26.6958 103.432 26.5626C103.555 26.4357 103.653 26.2772 103.718 26.1122V26.1058C103.776 25.9536 103.809 25.7887 103.809 25.6238C103.809 25.4271 103.757 25.2241 103.673 25.0465V25.0402C103.341 24.336 102.924 23.6953 102.423 23.1244C101.922 22.5534 101.33 22.0523 100.66 21.621C99.9765 21.1832 99.2479 20.8534 98.4867 20.6314C97.725 20.4093 96.9313 20.3015 96.1051 20.3015C94.9661 20.3015 93.8927 20.4981 92.9104 20.8978C91.9214 21.2974 91.0235 21.8937 90.2165 22.6804C89.4096 23.467 88.7979 24.3423 88.3881 25.3065C87.9782 26.2708 87.7764 27.3111 87.7764 28.4213C87.7764 29.5314 87.9782 30.5781 88.3881 31.536C88.7979 32.5002 89.4096 33.3756 90.2165 34.1622C91.0235 34.9488 91.9214 35.5451 92.9104 35.9447C93.8993 36.3444 94.9661 36.541 96.1051 36.541C96.9898 36.541 97.8486 36.4142 98.6621 36.1604C99.4757 35.9067 100.25 35.5261 100.979 35.0186C101.688 34.5238 102.293 33.9465 102.787 33.2931C103.282 32.6461 103.679 31.9166 103.959 31.1236V31.1173C104.017 30.965 104.05 30.8001 104.05 30.6352C104.05 30.4703 104.03 30.3307 103.985 30.2038ZM90.6914 28.9732C90.6655 28.7448 90.6589 28.5672 90.6589 28.4467C90.6589 27.7044 90.789 27.0257 91.056 26.404C91.3158 25.7823 91.7129 25.2114 92.2463 24.6849C92.7868 24.1584 93.372 23.7714 94.0096 23.5113C94.6473 23.2513 95.3439 23.1244 96.1051 23.1244C96.9506 23.1244 97.7383 23.3147 98.4928 23.7016C99.0918 24.0061 99.6643 24.4375 100.224 25.0021L90.7173 29.1952C90.7046 29.1127 90.698 29.043 90.6914 28.9732Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M108.565 15.0617C108.494 14.8905 108.389 14.7382 108.253 14.6113L108.247 14.605L108.24 14.5986C108.11 14.4781 107.954 14.3766 107.784 14.3131C107.615 14.2497 107.433 14.218 107.251 14.218H107.205C107.023 14.218 106.841 14.2497 106.672 14.3131C106.502 14.3766 106.346 14.4781 106.216 14.5986L106.21 14.605L106.204 14.6113C106.073 14.7382 105.963 14.8968 105.891 15.0617C105.82 15.233 105.787 15.417 105.787 15.5946V35.1391C105.787 35.3167 105.82 35.5007 105.891 35.6656C105.963 35.8306 106.073 35.9828 106.204 36.1097C106.333 36.2366 106.49 36.3444 106.659 36.4142C106.828 36.4839 107.017 36.5157 107.199 36.5157H107.244C107.426 36.5157 107.615 36.4839 107.784 36.4142C107.954 36.3444 108.11 36.2366 108.24 36.1097C108.37 35.9828 108.48 35.8306 108.552 35.6656C108.624 35.5007 108.656 35.3167 108.656 35.1391V15.5946C108.67 15.417 108.637 15.233 108.565 15.0617Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_597_14515",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 21,
    width: 13,
    height: 13
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3407 31.0734C34.5595 28.9165 34.566 25.4086 32.3537 23.2391C30.1414 21.0696 26.5431 21.0696 24.3178 23.2264C22.099 25.3832 21.7737 31.3715 22.8798 32.4499C23.9795 33.5283 30.1154 33.2302 32.3407 31.0734Z",
    fill: "url(#paint1_linear_597_14515)"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_597_14515)"
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.0192,
    cy: 24.9375,
    rx: 10.6442,
    ry: 10.6875,
    fill: "url(#paint2_linear_597_14515)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.0192,
    cy: 24.9375,
    rx: 10.6442,
    ry: 10.6875,
    fill: "url(#paint3_radial_597_14515)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.0192,
    cy: 24.9375,
    rx: 10.6442,
    ry: 10.6875,
    fill: "url(#paint4_radial_597_14515)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.0192,
    cy: 24.9375,
    rx: 10.6442,
    ry: 10.6875,
    fill: "url(#paint5_radial_597_14515)"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.0192,
    cy: 24.9375,
    rx: 10.6442,
    ry: 10.6875,
    fill: "url(#paint6_radial_597_14515)"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.0192,
    cy: 24.9375,
    rx: 10.6442,
    ry: 10.6875,
    fill: "url(#paint7_radial_597_14515)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.0192,
    cy: 24.9375,
    rx: 10.6442,
    ry: 10.6875,
    fill: "url(#paint8_linear_597_14515)"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.0192,
    cy: 24.9375,
    rx: 10.6442,
    ry: 10.6875,
    fill: "url(#paint9_radial_597_14515)"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.0192,
    cy: 24.9375,
    rx: 10.6442,
    ry: 10.6875,
    fill: "url(#paint10_radial_597_14515)"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.0192,
    cy: 24.9375,
    rx: 10.6442,
    ry: 10.6875,
    fill: "url(#paint11_radial_597_14515)"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.0192,
    cy: 24.9375,
    rx: 10.6442,
    ry: 10.6875,
    fill: "url(#paint12_radial_597_14515)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_597_14515",
    x1: 22.2691,
    y1: 27.3331,
    x2: 34.0107,
    y2: 27.3331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0128742,
    stopColor: "#7284FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2559,
    stopColor: "#7282FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3435,
    stopColor: "#747BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4059,
    stopColor: "#7670FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4563,
    stopColor: "#795FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4991,
    stopColor: "#7C49FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.513,
    stopColor: "#7E40FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6877,
    stopColor: "#7C3EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7904,
    stopColor: "#7735FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8746,
    stopColor: "#6E27FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9483,
    stopColor: "#6213FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5600FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_597_14515",
    x1: 22.2691,
    y1: 27.3331,
    x2: 34.0107,
    y2: 27.3331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0128742,
    stopColor: "#7284FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2559,
    stopColor: "#7282FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3435,
    stopColor: "#747BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4059,
    stopColor: "#7670FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4563,
    stopColor: "#795FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4991,
    stopColor: "#7C49FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.513,
    stopColor: "#7E40FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6877,
    stopColor: "#7C3EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7904,
    stopColor: "#7735FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8746,
    stopColor: "#6E27FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9483,
    stopColor: "#6213FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5600FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_597_14515",
    x1: 26.0192,
    y1: 16.6992,
    x2: 30.9342,
    y2: 32.7193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A893E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9EA1DC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_597_14515",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.0024 34.2891) rotate(-130.74) scale(10.8731 10.4162)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#606EF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#909ADD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_597_14515",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.3413 14.25) rotate(116.472) scale(11.9393 11.4165)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8874FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8874FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_597_14515",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.7139 13.3594) rotate(36.7184) scale(19.3652 15.7207)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_597_14515",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.149 16.0312) rotate(45.1162) scale(7.85617 5.70587)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_597_14515",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.1318 24.9375) rotate(50.0136) scale(6.02333 4.9664)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_597_14515",
    x1: 26.0192,
    y1: 16.6992,
    x2: 30.9342,
    y2: 32.7193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A893E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9EA1DC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_597_14515",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.0024 34.2891) rotate(-130.74) scale(10.8731 10.4162)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#606EF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#909ADD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_597_14515",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.3413 14.25) rotate(116.097) scale(13.9179 13.3079)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8874FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8874FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_597_14515",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.7139 13.3594) rotate(39.809) scale(19.7931 16.0612)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_597_14515",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.149 16.0312) rotate(43.6274) scale(11.2584 8.17864)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLogo);
export default __webpack_public_path__ + "static/media/footerLogo.3e3e2be43e9a7c61f0aacd031d314fd8.svg";
export { ForwardRef as ReactComponent };